<template>
<b-container fluid v-if="laneClosureRequest != null && loaded">
	<lane-closure-request-quick-nav v-if="!$store.state.isMobile" v-model="laneClosureRequest" selected="report-closure"></lane-closure-request-quick-nav>
	<b-row>
	<b-col :cols="isHideMapAndDesktop ? '6' : null" :style="isHideMapAndDesktop ? 'flex: 0 0 56%; max-width: 56%' : null">
	<b-container class="report-closure-container">
		<b-row v-if="$store.state.isMobile">
			<b-col class="pt-0 lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" xl="9">
				<div class="d-flex lcr-page-title">
					<div>
						<h1>Close / Re-open Lane(s)</h1>
					</div>
				</div>
			</b-col>
		</b-row>
		<b-row :class="$store.state.isMobile ? 'lcr-detail-mobile-wrapper' : ''">
			<b-col v-if="!$store.state.isMobile" class="lcr-quick-nav-summary" sm="12">
				<b-row>
					<b-col>
						<h1>Close / Re-open Lane(s)</h1>
					</b-col>
				</b-row>
				<b-row v-if="laneClosureRequest.requesterProjectName">
					<b-col class="pt-1">
						<h2>Project: {{laneClosureRequest.requesterProjectName}}</h2>
					</b-col>
				</b-row>
				<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
				<!-- <div class="d-flex lcr-main-summary">

					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Info</div>
						<div class="lcr-summary__value" v-show="laneClosureRequest.trafficManagementRef.value">TM: {{laneClosureRequest.trafficManagementRef.value}}</div>
						<div class="lcr-summary__value">LCR: {{laneClosureRequest.id}}</div>


						<div class="lcr-summary__label">Requester</div>
						<div class="lcr-summary__value">
							<div v-if="laneClosureRequest.requester">{{laneClosureRequest.requester.firstName}} {{laneClosureRequest.requester.lastName}}</div>
							<div v-if="laneClosureRequest.altRequester.length > 0">
								<div v-for="contact in laneClosureRequest.altRequester" v-bind:key="'c'+contact.userId">{{contact.firstName}} {{contact.lastName}}</div>
							</div>
						</div>


					</div>
					<div class="lcr-main-summary__info flex-grow-1">
						<div class="lcr-summary__label">Affected Streets</div>
						<div class="lcr-summary__value">{{directionOfTravel}}</div>
						<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
						<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
					</div>
					<div class="lcr-main-summary__info pt-4">
						<div class="show-on-map-wrapper">
							<a class="show-on-map text-left" @click="showOnMap">
								<span v-if="hideMap" class="on-container">
									<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
									<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
								</span>
								<span v-else class="on-container">
									<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
									<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
								</span>
							</a>
						</div>
					</div>
					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Primary Reason for Closure</div>
						<div class="lcr-summary__value">{{natureOfWork}}</div>
					</div>
					<div class="lcr-main-summary__info ">
						<div class="lcr-summary__label">Date(s)</div>
						<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'MM/DD/YYYY')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'MM/DD/YYYY')}}</div>
						<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'H:mm')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'H:mm')}}</div>
					</div>
					<div class="lcr-main-summary__info" v-if="laneClosureRequest.completeTypeId.value != null">
						<div class="lcr-summary__label">Complete Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.completeTypeId.value)}}</div>
					</div>
					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Approval Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.approvalStatusId.value)}}</div>
						<div class="lcr-summary__label">Record Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.recordStatusId.value)}}</div>
					</div>

				</div> -->

			</b-col>
			<b-col v-if="$store.state.isMobile" class="lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12">
				<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
			</b-col>
		</b-row>


		<div v-show="!canReportClosure" class="mt-3">
			<div>
				<p style="font-weight:bold;" v-html="cannotReportReason"></p>
				<b-button @click="onViewLaneClosureRequest">View Request</b-button>
			</div>
		</div>
		<div v-show="canReportClosure">
			<b-row :style="backgroundColorStyle">
				<b-col>
					<h3 class="affected-lanes-mobile" v-show="!$store.state.isMobile">What lanes are affected in this report?</h3>
					<b-row v-if="!$store.getters.isReadOnly()">
						<b-col>
							<b-button v-show="!$store.state.isMobile" @click="onAllLanesClosed" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />All Closed</b-button>
							<b-button v-show="!$store.state.isMobile" @click="onAllLanesOpen" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />All Open</b-button>
<!-- 							<b-button variant="outline-primary" class="mr-1" type="button" @click="onAllLanesClosed" v-show="!$store.state.isMobile"><i class='status-circle-solid lc-closed'></i> Set All Closed</b-button>
							<b-button variant="outline-primary" type="button" @click="onAllLanesOpen" v-show="!$store.state.isMobile"><i class='status-circle-solid lc-open'></i> Set All Open</b-button><br />
 -->							<br v-if="!$store.state.isMobile" />
							<div v-show="$store.state.isMobile" class="mobile-affect-title">
								<h1>Affected Lane(s)</h1>
								<p>Close/open individually or use "Set All..." buttons below, then tap Save.</p>
							</div>
						</b-col>
					</b-row>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(1)" :expand="expandCustomizeLane['1']" :laneId="1" v-bind:key="'viewlaneListing1-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(2)" :expand="expandCustomizeLane['2']" :laneId="2" v-bind:key="'viewlaneListing2-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(24)" :expand="expandCustomizeLane['24']" :laneId="24" v-bind:key="'viewlaneListing24-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(25)" :expand="expandCustomizeLane['25']" :laneId="25" v-bind:key="'viewlaneListing25-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(3)" :expand="expandCustomizeLane['3']" :laneId="3" v-bind:key="'viewlaneListing3-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(15)" :expand="expandCustomizeLane['15']" :laneId="15" v-bind:key="'viewlaneListing15-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(32)" :expand="expandCustomizeLane['32']" :laneId="32" v-bind:key="'viewlaneListing32-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(33)" :expand="expandCustomizeLane['33']" :laneId="33" v-bind:key="'viewlaneListing33-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(19)" :expand="expandCustomizeLane['19']" :laneId="19" v-bind:key="'viewlaneListing19-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(44)" :expand="expandCustomizeLane['44']" :laneId="44" v-bind:key="'viewlaneListing44-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(40)" :expand="expandCustomizeLane['40']" :laneId="40" v-bind:key="'viewlaneListing19-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>

					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(4)" :expand="expandCustomizeLane['4']" :laneId="4" v-bind:key="'viewlaneListing4-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(5)" :expand="expandCustomizeLane['5']" :laneId="5" v-bind:key="'viewlaneListing5-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(26)" :expand="expandCustomizeLane['26']" :laneId="26" v-bind:key="'viewlaneListing26-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(27)" :expand="expandCustomizeLane['27']" :laneId="27" v-bind:key="'viewlaneListing27-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(6)" :expand="expandCustomizeLane['6']" :laneId="6" v-bind:key="'viewlaneListing6-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(16)" :expand="expandCustomizeLane['16']" :laneId="16" v-bind:key="'viewlaneListing16-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(34)" :expand="expandCustomizeLane['34']" :laneId="34" v-bind:key="'viewlaneListing34-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(35)" :expand="expandCustomizeLane['35']" :laneId="35" v-bind:key="'viewlaneListing35-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(20)" :expand="expandCustomizeLane['20']" :laneId="20" v-bind:key="'viewlaneListing20-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(45)" :expand="expandCustomizeLane['45']" :laneId="45" v-bind:key="'viewlaneListing45-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(41)" :expand="expandCustomizeLane['41']" :laneId="41" v-bind:key="'viewlaneListing20-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>

					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(7)" :expand="expandCustomizeLane['7']" :laneId="7" v-bind:key="'viewlaneListing7-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(8)" :expand="expandCustomizeLane['8']" :laneId="8" v-bind:key="'viewlaneListing8-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(28)" :expand="expandCustomizeLane['28']" :laneId="28" v-bind:key="'viewlaneListing28-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(29)" :expand="expandCustomizeLane['29']" :laneId="29" v-bind:key="'viewlaneListing29-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(9)" :expand="expandCustomizeLane['9']" :laneId="9" v-bind:key="'viewlaneListing9-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(17)" :expand="expandCustomizeLane['17']" :laneId="17" v-bind:key="'viewlaneListing17-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(36)" :expand="expandCustomizeLane['36']" :laneId="36" v-bind:key="'viewlaneListing36-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(37)" :expand="expandCustomizeLane['37']" :laneId="37" v-bind:key="'viewlaneListing37-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(21)" :expand="expandCustomizeLane['21']" :laneId="21" v-bind:key="'viewlaneListing21-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(46)" :expand="expandCustomizeLane['46']" :laneId="46" v-bind:key="'viewlaneListing46-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(42)" :expand="expandCustomizeLane['42']" :laneId="42" v-bind:key="'viewlaneListing21-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>

					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(10)" :expand="expandCustomizeLane['10']" :laneId="10" v-bind:key="'viewlaneListing10-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(11)" :expand="expandCustomizeLane['11']" :laneId="11" v-bind:key="'viewlaneListing11-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(30)" :expand="expandCustomizeLane['30']" :laneId="30" v-bind:key="'viewlaneListing30-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(31)" :expand="expandCustomizeLane['31']" :laneId="31" v-bind:key="'viewlaneListing31-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(12)" :expand="expandCustomizeLane['12']" :laneId="12" v-bind:key="'viewlaneListing12-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(22)" :expand="expandCustomizeLane['22']" :laneId="22" v-bind:key="'viewlaneListing22-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(18)" :expand="expandCustomizeLane['18']" :laneId="18" v-bind:key="'viewlaneListing18-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(38)" :expand="expandCustomizeLane['38']" :laneId="38" v-bind:key="'viewlaneListing38-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(39)" :expand="expandCustomizeLane['39']" :laneId="39" v-bind:key="'viewlaneListing39-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(13)" :expand="expandCustomizeLane['13']" :laneId="13" v-bind:key="'viewlaneListing13-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(14)" :expand="expandCustomizeLane['14']" :laneId="14" v-bind:key="'viewlaneListing14-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(23)" :expand="expandCustomizeLane['23']" :laneId="23" v-bind:key="'viewlaneListing23-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(47)" :expand="expandCustomizeLane['47']" :laneId="47" v-bind:key="'viewlaneListing47-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>
					<report-lane-closure-request-block-lane-listing v-show="!isEditingBlock" v-if="hasLaneId(43)" :expand="expandCustomizeLane['43']" :laneId="43" v-bind:key="'viewlaneListing23-'+renderCounter" v-model="laneClosure.block" :uniqueLanes="laneClosureRequest.uniqueLanes" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-lane-listing>

					<b-alert variant="danger" v-if="hasMultipleSidewalks()" show><strong>NOTE: You cannot close sidewalks on both sides of the street at the same time.</strong></b-alert>

					<report-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(1)" :expand="expandCustomizeSidewalk['1']" :sidewalkId="1" v-bind:key="'viewsidewalkListing1-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-sidewalk-listing>
					<report-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(2)" :expand="expandCustomizeSidewalk['2']" :sidewalkId="2" v-bind:key="'viewsidewalkListing2-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-sidewalk-listing>
					<report-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(3)" :expand="expandCustomizeSidewalk['3']" :sidewalkId="3" v-bind:key="'viewsidewalkListing3-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-sidewalk-listing>
					<report-lane-closure-request-block-sidewalk-listing v-show="!isEditingBlock" v-if="hasSidewalkId(4)" :expand="expandCustomizeSidewalk['4']" :sidewalkId="4" v-bind:key="'viewsidewalkListing4-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-sidewalk-listing>

					<b-alert variant="danger" v-if="hasProtectedBikeLane()" show><strong>NOTE: Closing a protected bike lane requires a protected bike detour. Please check the traffic control manual for more information.</strong></b-alert>

					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(1)" :expand="expandCustomizeBicycle['1']" :bicycleLaneId="1" v-bind:key="'viewbicycleListing1-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(2)" :expand="expandCustomizeBicycle['2']" :bicycleLaneId="2" v-bind:key="'viewbicycleListing2-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(3)" :expand="expandCustomizeBicycle['3']" :bicycleLaneId="3" v-bind:key="'viewbicycleListing3-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(4)" :expand="expandCustomizeBicycle['4']" :bicycleLaneId="4" v-bind:key="'viewbicycleListing4-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(5)" :expand="expandCustomizeBicycle['5']" :bicycleLaneId="5" v-bind:key="'viewbicycleListing5-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(6)" :expand="expandCustomizeBicycle['6']" :bicycleLaneId="6" v-bind:key="'viewbicycleListing6-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(7)" :expand="expandCustomizeBicycle['7']" :bicycleLaneId="7" v-bind:key="'viewbicycleListing7-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(8)" :expand="expandCustomizeBicycle['8']" :bicycleLaneId="8" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(9)" :expand="expandCustomizeBicycle['9']" :bicycleLaneId="9" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(10)" :expand="expandCustomizeBicycle['10']" :bicycleLaneId="10" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(11)" :expand="expandCustomizeBicycle['11']" :bicycleLaneId="11" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>
					<report-lane-closure-request-block-bicycle-listing v-show="!isEditingBlock" v-if="hasBicycleId(12)" :expand="expandCustomizeBicycle['12']" :bicycleLaneId="12" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosure.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-bicycle-listing>

					<h1 v-show="$store.state.isMobile && canSetTrafficEffect"><label for="ta-traffic-effect">Traffic Effect</label></h1>
					<div class="request__user__info" v-show="canSetTrafficEffect">
					<b-row>
						<b-col>
							<b-form-group label="Traffic Effect" label-for="ta-traffic-effect" :state="laneClosure.trafficEffect.status" :invalid-feedback="laneClosure.trafficEffect.invalidMessage">
								<wysiwyg id="ta-traffic-effect" rows="4" no-resize v-model="laneClosure.trafficEffect.value" @input="laneClosure.trafficEffect.resetStatus()" :state="laneClosure.trafficEffect.status">
								</wysiwyg>
							</b-form-group>
						</b-col>
					</b-row>
					</div>

					<h1 v-show="$store.state.isMobile">Attachments</h1>
					<div class="request__user__info">
					<b-row>
						<b-col sm="12">
							<div v-if="!$store.state.isMobile" class="lcr-summary__label">Attachments</div>
							<div v-if="!$store.getters.isReadOnly()" class="attachment__uploader">
							<file-pond credits="false" name="attachment" ref="pond" label-idle="<span class='filepond--label-action'>Select files</span>" v-bind:allow-multiple="true"
								accepted-file-types="image/jpeg, image/png, application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-ms-excel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint"
								v-on:init="handleFilePondInit" v-on:addfile="handleFilePondAddFile" v-on:processfilestart="handleFilePondProcessFileStart" v-on:processfiles="handleFilePondProcessAllFiles" v-on:processfileabort="handleFilePondProcessAbort" v-on:error="handleFilePondProcessError"  v-on:processfile="handleFilePondProcessFile">
							</file-pond>
							</div>
						</b-col>
						<b-col sm="12">
							<attachments-list  :sourceId="null" a:sourceTable="'lc_attachment'" v-model="laneClosure" :downloadToken="downloadToken" :downloadTokenExpires="downloadTokenExpires" ref="refAttachments"></attachments-list>
						</b-col>
					</b-row>
					</div>

					<h1 v-show="$store.state.isMobile">Reporter</h1>
					<div class="request__user__info">
						<b-row v-if="!$store.getters.isReadOnly()">
							<b-col sm="12" lg="6">
								<b-form-group id="ig-primary-contact" label="Who is making this report?" label-for="input-lcr-primary-contact" description="" :state="selectReporter.status" :invalid-feedback="selectReporter.invalidMessage">
									<div v-if="reporter" class="contact">
										<div class="contact__name">{{reporter.firstName}} {{reporter.lastName}}</div>
										<div class="contact__organization">{{reporter.organizationName}}</div>
										<div class="contact__phone">{{reporter.phone}}</div>
									</div>
									<autocomplete data-position="above" v-if="!$store.getters.isReadOnly()" :search="SearchReporter" :get-result-value="SearchReporterValue" @submit="HandleSelectReporter" placeholder="Start typing to select Reporter" aria-label="Start typing to select Reporter" ref="searchReporter" auto-select>
										<template v-slot:result=" {result, props } ">
											<li v-bind="props" class="autocomplete-result primary-contact-result">
												<div class="contact-name">{{result.firstName}} {{result.lastName}}</div>
												<div class="contact-organization">{{result.organizationName}}</div>
												<div class="contact-phone">{{result.phone}}</div>
											</li>
										</template>
									</autocomplete>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row v-if="!$store.getters.isReadOnly()">
							<b-col class="pt-3" sm="12" md="12">
								<b-row>
									<b-col cols="12" md="6">
										<b-form-group id="ig-report-start-date" label="Reporting Date" label-for="input-report-start-date" :state="laneClosure.fromDateTime.status" :invalid-feedback="laneClosure.fromDateTime.invalidMessage">
											<date-picker :disabled=$store.getters.isReadOnly() bootstrap-styling id="input-report-start-date" format="MM/dd/yyyy" v-model="laneClosureFromDateTimePicker" :input-class="{'is-invalid': laneClosure.fromDateTime.status == false}" @input="laneClosure.fromDateTime.resetStatus(); checkLessThanTwoHours();" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
										</b-form-group>
									</b-col>
									<b-col cols="12" md="6">
										<b-form-group id="ig-report-start-time" label="Reporting Time" label-for="input-report-start-time" :state="laneClosure.fromDateTime.status" :invalid-feedback="laneClosure.fromDateTime.invalidMessage">
											<bootstrap-text-time-picker :disabled=$store.getters.isReadOnly() ref="refTimeFrom" v-model="laneClosure.fromDateTime.value" v-on:update:time="onFromDateTimeChanged"></bootstrap-text-time-picker>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row  v-if="canReportRestriction && !$store.getters.isReadOnly()" >
							<b-col class="mt-2">
								<b-form-group label="Place or Remove turning restrictions after saving this report?">
									<div class="yes-no-switch-field">
											<input id="reportRestrictionAfter" :disabled=$store.getters.isReadOnly()  class="yes-no-switch" :checked="setRestrictionsAfter == true" type="checkbox" @change="setRestrictionsAfter = !setRestrictionsAfter" >
											<label for="reportRestrictionAfter"></label>
									</div>
								</b-form-group>
							</b-col>
						</b-row>
					</div>
					<b-row v-if="!$store.getters.isReadOnly()" v-show="!$store.state.isMobile">
						<b-col class="mt-2">
							<b-button :disabled="isButtonDisabled" variant="primary" class="mr-1" type="button" @click="onSubmitOnly">Save Report <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
							</b-button>
							<!-- <b-button variant="primary" type="button" v-show="canReportRestriction" @click="onSubmitAndSetRestrictions">Save Report and Set Restrictions <b-spinner small label="Saving..." class="ml-2" v-if="savingAndSet"></b-spinner>
							</b-button> -->
							<b-button variant="text" class="mr-1" type="button" @click="onCancel">Cancel Report</b-button>
						</b-col>
					</b-row>
					<div style="height: 25px;" v-show="$store.state.isMobile"></div>

					<div class="actions-bar"  v-show="$store.state.isMobile">
						<div class="d-flex">
							<div class="actions-bar__close"><b-button @click="onAllLanesClosed" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />All Closed</b-button></div>
							<div class="actions-bar__open"><b-button @click="onAllLanesOpen" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />All Open</b-button></div>
							<div class="actions-bar__save"><b-button :disabled="isButtonDisabled" @click="onSubmitOnly" variant="primary" class="save-button" type="button"><b-spinner small label="Saving..." class="mr-2" v-if="saving"></b-spinner><span v-if="!saving" class="btn__icon"><img src="/img/assets/icon-checkmark.svg"/></span><span class="btn__text">Save</span></b-button></div>
						</div>
					</div>
				</b-col>
			</b-row>
		</div>
	</b-container>
	</b-col>
	<b-col cols="6" style="flex: 0 0 44%; max-width: 44%" v-if="hideMap">
	</b-col>
	</b-row>
	<!-- leaving page -->
	<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
		<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
		<template v-slot:modal-footer="{ ok }">
			<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
			<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
			<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
		</template>
	</b-modal>

</b-container>
<Spinner v-else />
</template>
<script>
import LaneClosureRequest from '../../models/LaneClosureRequest';
import LaneClosureRequestQuickNav from '../../components/LaneClosureRequestQuickNav.vue';
import LaneClosureViewInfo from '../../components/LaneClosureViewInfo.vue';
import LaneClosureRequestBlock from '../../models/LaneClosureRequestBlock';
import LaneClosure from '../../models/LaneClosure';

import Datepicker from 'vuejs-datepicker';
import BootstrapField from '../../utility/BootstrapField';
import BootstrapTextTimePicker from '../../components/bootstrap-text-time-picker.vue';
import Autocomplete from '@trevoreyre/autocomplete-vue'

import Spinner from "./../../components/Spinner.vue";

import Format from '../../utility/Format';

import ErrorHandler from '../../utility/ErrorHandler';
import { gmapApi } from 'gmap-vue'
import KMLHelper from '../../utility/KMLHelper';

import Attachment from '../../models/Attachment';

import AttachmentsList from '../../components/AttachmentsList.vue';
// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';


import ReportLaneClosureRequestBlockLaneListing from '../../components/ReportLaneClosureRequestBlockLaneListing';
import ReportLaneClosureRequestBlockSidewalkListing from '../../components/ReportLaneClosureRequestBlockSidewalkListing';
import ReportLaneClosureRequestBlockBicycleListing from '../../components/ReportLaneClosureRequestBlockBicycleListing';


import Vue from 'vue'
export default {
	name: 'ReportClosure',
	docTitle() {
		return `Request ${this.id} Report Closure - Lane Closures`
	},

	components: {
		LaneClosureViewInfo,
		LaneClosureRequestQuickNav,
		Autocomplete,
		'date-picker': Datepicker,
		BootstrapTextTimePicker,
		'attachments-list': AttachmentsList,
		FilePond: vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileMetadata, FilePondPluginFileRename),
		ReportLaneClosureRequestBlockLaneListing,
		ReportLaneClosureRequestBlockSidewalkListing,
		ReportLaneClosureRequestBlockBicycleListing,
		Spinner,
	},
	props: ['id'],
	data() {
		return {
			Format,
			overrideUnsavedChanges: false,
			// Editable methods for the modal.
			modalOnSave: () => {},
			modalOnLeave: () => {},
			map: null,
			mapPaths: null,
			mapPlacemarks: [],
			Attachment,
			downloadToken:null,
			downloadTokenExpires:null,
			editingBlockIndex: -1,
			expandAffectedStreet: false,
			expandBicycle: false,
			expandCustomizeBicycle: [],
			expandCustomizeLane: [],
			expandCustomizeRestriction: [],
			expandCustomizeSidewalk: [],
			markers: [],
			laneClosure: null,
			isEditingBlock: false,
			LaneClosureRequest,
			laneClosureRequest: null,
			submitted: null,
			allStreetOptions: [],
			noFirstCrossStreetOptions: [{
				text: 'Select Affected Street',
				value: null
			}],
			noLastCrossStreetOptions: [{
				text: 'Select First Cross Street',
				value: null
			}],
			file: null,
			newRestriction: {
				blockId: new BootstrapField({
					value: null,
				}),
				laneId: new BootstrapField({
					value: null,
				}),
				restrictionTypeId: new BootstrapField({
					value: 1,
				}),
				affectedStreet: new BootstrapField({
					value: null,
				}),
				crossStreet: new BootstrapField({
					value: null,
				})
			},
			onSubmitPromiseDeferred: {
				resolve: null,
				reject: null
			},
			setRestrictionsAfter: false,
			renderCounter: 0,
			saving: false,
			savingAndSet: false,
			showUnsavedChangesModal: false,
			lineIndexError: null,
			isButtonDisabled: false,
			saveState: null,
			modalRequiredFieldList: [],
			selectReporter: new BootstrapField({
				value: null,
			}),
			showRequiredFieldModal: false,
			requesterProjectInfo: null, // have to save the project information, in case they change the user, the project will be gone.
			ownerInfo: null,
			reporter: null,
			refSearchReporter: null,
			show: true,
			hideMap: false,
		}
	},
	mounted() {
		this.collapseAll();
		this.setEventBusOn();
		// TODO: verify their permissions for this lane closure request.
		// this.getPermission();
		this.LoadLaneClosureRequest();

		var main = document.getElementById("main");
		main.scrollTo(0, 0);

	},
	computed: {
		laneClosureFromDateTimePicker: {
			get() {
				return Format.utcToPickerDate(
					this.laneClosure.fromDateTime.value
				);
			},
			set(date) {
				this.laneClosure.fromDateTime.value =
				Format.mergePickerDate(
					this.laneClosure.fromDateTime.value,
					date
				);
			}
		},

		isHideMapAndDesktop() {
			return this.hideMap && !this.$store.state.isMobile;
		},
		canSetTrafficEffect() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('internal_admin_requests')) {
					return true;
				}
			}
			return false;
		},
		cannotReportReason() {
			var hasLanes = false;
			let text = null;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2) {
					if (this.laneClosureRequest.recordStatusId.value != 7) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].lane) {
								if (this.laneClosureRequest.block[x].lane.length > 0) {
									hasLanes = true;
								}
							}
							if (this.laneClosureRequest.block[x].bicycle) {
								if (this.laneClosureRequest.block[x].bicycle.length > 0) {
									hasLanes = true;
								}
							}
							if (this.laneClosureRequest.block[x].sidewalk) {
								if (this.laneClosureRequest.block[x].sidewalk.length > 0) {
									hasLanes = true;
								}
							}
						}
						if (!hasLanes ) {
							text = "This request does not have any road lanes, bicycle lanes, or sidewalks.";
						}
					} else {
						text = "This request was already completed.";
					}
				} else {
					text = "This request cannot have lane closures reported until it is Approved.";
				}
			}

			if (text == null) {
				if (!this.canReportClosure) {
					text = "You do not have permission to report lanes closed or opened for this request.";
				}
			}
			return text;
		},

		canReportRestriction() {
			if (this.laneClosureRequest && this.$store.getters.userInfo()) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let canReport = false;
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canReportOrg = this.$store.getters.userHasPermission('rr_org');
					let canReportMine = this.$store.getters.userHasPermission('rr_mine');
					let canReportAll = this.$store.getters.userHasPermission('rr_all');

					if (!canReportMine && !canReportAll && !canReportOrg) {
						return false;
					}

					if (canReportAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.restrictionReporterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canReportOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altRestrictionReporter) {
							for (x = 0; x < this.laneClosureRequest.altRestrictionReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRestrictionReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRestrictionReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].restriction.length > 0) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},

		canReportClosure() {
			let canReport = false;
			if (this.laneClosureRequest && this.$store.getters.userInfo()) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canReportOrg = this.$store.getters.userHasPermission('rlc_org');
					let canReportMine = this.$store.getters.userHasPermission('rlc_mine');
					let canReportAll = this.$store.getters.userHasPermission('rlc_all');



					if (!canReportMine && !canReportAll && !canReportOrg) {
						return false;
					}

					if (canReportAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.closureReporterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canReportOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altClosureReporter) {
							for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].lane) {
								if (this.laneClosureRequest.block[x].lane.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].bicycle) {
								if (this.laneClosureRequest.block[x].bicycle.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].sidewalk) {
								if (this.laneClosureRequest.block[x].sidewalk.length > 0) {
									return true;
								}
							}
						}
					}
				}
			}
			return canReport;
		},

		googleMap: gmapApi,
		disableStartDate() {
			return {
						to: Format.utcToPickerDate(
								Format.startOfLocalDay().utc().format()
						)
			};
		},
		disableEndDate() {
			if (this.laneClosureRequest.fromDate &&
			this.laneClosureRequest.fromDate.value) {
				return {
					to: new Date(
					Format.utcToPickerDate(
					this.laneClosureRequest.fromDate.value
					).setHours(0, 0, 0, -1)
					)
				};
			}

			return {};
		},
		friendlyFromToDate() {
			// let diff = Format.diffYMDHMS(this.laneClosureRequest.fromDate.value, this.laneClosureRequest.toDate.value);
			return null;
		},
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				return Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},
		getPeakIdText() {
			if (this.laneClosureRequest.peakId.value) {
				return Format.searchById(this.laneClosureRequest.peakId.value, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},

		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		},

		backgroundColorStyle() {
			if (this.$store.state.isMobile) {
				return "background-color: #DFDFEB;";

			} else {
				return "";
			}
		},
	},

	watch: {
		'$route.params': function() {
			// for changing route within the same component
			this.LoadLaneClosureRequest(this.$route.params.id);
		},
	},

	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {

		anyExpanded() {
			var isExpanded = false;
			for (var x in this.expandCustomizeLane) {
				if (this.expandCustomizeLane[x] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}

			for (var x2 in this.expandCustomizeSidewalk) {
				if (this.expandCustomizeSidewalk[x2] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}
			for (var x3 in this.expandCustomizeBicycle) {
				if (this.expandCustomizeBicycle[x3] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}
		},

		collapseAll() {
			this.expandCustomizeLane["40"] = false;
			this.expandCustomizeLane["41"] = false;
			this.expandCustomizeLane["42"] = false;
			this.expandCustomizeLane["43"] = false;

			this.expandCustomizeLane["44"] = false;
			this.expandCustomizeLane["45"] = false;
			this.expandCustomizeLane["46"] = false;
			this.expandCustomizeLane["47"] = false;

			this.expandCustomizeLane["1"] = false;
			this.expandCustomizeLane["2"] = false;
			this.expandCustomizeLane["24"] = false;
			this.expandCustomizeLane["25"] = false;
			this.expandCustomizeLane["3"] = false;
			this.expandCustomizeLane["15"] = false;
			this.expandCustomizeLane["32"] = false;
			this.expandCustomizeLane["33"] = false;
			this.expandCustomizeLane["19"] = false;
			this.expandCustomizeLane["4"] = false;
			this.expandCustomizeLane["5"] = false;
			this.expandCustomizeLane["26"] = false;
			this.expandCustomizeLane["27"] = false;
			this.expandCustomizeLane["6"] = false;
			this.expandCustomizeLane["16"] = false;
			this.expandCustomizeLane["34"] = false;
			this.expandCustomizeLane["35"] = false;
			this.expandCustomizeLane["20"] = false;
			this.expandCustomizeLane["7"] = false;
			this.expandCustomizeLane["8"] = false;
			this.expandCustomizeLane["28"] = false;
			this.expandCustomizeLane["29"] = false;
			this.expandCustomizeLane["9"] = false;
			this.expandCustomizeLane["17"] = false;
			this.expandCustomizeLane["36"] = false;
			this.expandCustomizeLane["37"] = false;
			this.expandCustomizeLane["21"] = false;
			this.expandCustomizeLane["10"] = false;
			this.expandCustomizeLane["11"] = false;
			this.expandCustomizeLane["30"] = false;
			this.expandCustomizeLane["31"] = false;
			this.expandCustomizeLane["12"] = false;
			this.expandCustomizeLane["22"] = false;
			this.expandCustomizeLane["18"] = false;
			this.expandCustomizeLane["38"] = false;
			this.expandCustomizeLane["39"] = false;
			this.expandCustomizeLane["13"] = false;
			this.expandCustomizeLane["14"] = false;
			this.expandCustomizeLane["23"] = false;

			this.expandCustomizeSidewalk["1"] = false;
			this.expandCustomizeSidewalk["2"] = false;
			this.expandCustomizeSidewalk["3"] = false;
			this.expandCustomizeSidewalk["4"] = false;

			this.expandCustomizeBicycle["1"] = false;
			this.expandCustomizeBicycle["2"] = false;
			this.expandCustomizeBicycle["3"] = false;
			this.expandCustomizeBicycle["4"] = false;
			this.expandCustomizeBicycle["5"] = false;
			this.expandCustomizeBicycle["6"] = false;
			this.expandCustomizeBicycle["7"] = false;
			this.expandCustomizeBicycle["8"] = false;
		},
		getOrganizationIdTreeList(user) {
			if (user.organizationIdTree) {
				let treeString = user.organizationIdTree;
				let treeList = treeString.split("|");
				treeList.pop();
				treeList.shift();
				treeList.reverse();
				return treeList;
			} else {
				return new Array(user.organizationId);
			}
		},
		modalOnCancel() {
			this.showUnsavedChangesModal = false;
		},
		forceRerender() {
			this.renderCounter += 1;
			this.blockDetailsKey = "blockDetailsKey-" + this.renderCounter;
			this.blockClosuresRestrictionsKey = "blockClosuresRestrictionsKey-" + this.renderCounter;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.renderCounter;
			this.forceRerenderBlockEditDetails();
		},
		forceRerenderBlockEditDetails() {
			this.blockEditDetailsKeyCounter += 1;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.blockEditDetailsKeyCounter;
		},

		hasProtectedBikeLane() {

			for (let x = 0; x < this.laneClosureRequest.presetBlock[0].bicycle.length; x++ ){
				if (this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 2||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 2||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 4||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 6||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 8||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 9||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 10||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 11||
				this.laneClosureRequest.presetBlock[0].bicycle[x].bicycleLaneId.getValue() == 12
				) {
					return true;
				}
			}
			return false;
		},

		hasMultipleSidewalks() {
			if (this.laneClosureRequest.presetBlock[0].sidewalk) {
				if (this.laneClosureRequest.presetBlock[0].sidewalk.length > 1) {
					return true;
				}
			}
			return false;
		},

		hasSidewalkId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].sidewalk) {
						for (x = 0; x < this.laneClosureRequest.block[xx].sidewalk.length; x++) {
							if (this.laneClosureRequest.block[xx].sidewalk[x].sidewalkId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},
		hasLaneId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.presetBlock[0].lane.length; xx++) {
					if (this.laneClosureRequest.presetBlock[0].lane[xx].laneId.value == id) {
						return true;
					}
				}


				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].lane) {
						for (x = 0; x < this.laneClosureRequest.block[xx].lane.length; x++) {
							if (this.laneClosureRequest.block[xx].lane[x].laneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}

			return found;
		},

		hasBicycleId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].bicycle) {
						for (x = 0; x < this.laneClosureRequest.block[xx].bicycle.length; x++) {
							if (this.laneClosureRequest.block[xx].bicycle[x].bicycleLaneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},

		setEventBusOff() {
			this.$bus.$off('report-closure:map:block-edit', this.onMapBlockClick);
			this.$bus.$off('report-closure-block-details:toggle-lane-in-effect', this.toggleLaneInEffect);
			this.$bus.$off('report-closure-block-details:toggle-sidewalk-in-effect', this.toggleSidewalkInEffect);
			this.$bus.$off('report-closure-block-details:toggle-bicycle-in-effect', this.toggleBicycleInEffect);
			this.$bus.$off('report-closure-block-details:all-lanes-in-effect', this.toggleAllLanesInEffect);
			this.$bus.$off('report-closure-block-details:all-lanes-in-effect-peak', this.toggleAllLanesInEffectPeak);

			this.$bus.$off('swipe:right', this.onSwipeRight);


			this.$bus.$off('block:list-expand-lane', this.onToggleExpandCustomizeLane);
			this.$bus.$off('block:list-expand-sidewalk', this.onToggleExpandCustomizeSidewalk);
			this.$bus.$off('block:list-expand-bicycle', this.onToggleExpandCustomizeBicycle);
			this.$bus.$off('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$off('block:show-on-map', this.showBlockOnMap);

			this.$bus.$off('map:shown', this.changeToHideMap);
			this.$bus.$off('map:hidden', this.changeToShowMap);

			this.$bus.$off("attachment:updateComment",this.SaveAttachmentComment);
			this.$bus.$off("attachment:autoSave",this.SaveAttachmentComment);
			this.$bus.$off("attachment:delete", this.deleteAttachment);
		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('report-closure:map:block-edit', this.onMapBlockClick);
			this.$bus.$on('report-closure-block-details:toggle-lane-in-effect', this.toggleLaneInEffect);
			this.$bus.$on('report-closure-block-details:toggle-sidewalk-in-effect', this.toggleSidewalkInEffect);
			this.$bus.$on('report-closure-block-details:toggle-bicycle-in-effect', this.toggleBicycleInEffect);
			this.$bus.$on('report-closure-block-details:all-lanes-in-effect', this.toggleAllLanesInEffect);
			this.$bus.$on('report-closure-block-details:all-lanes-in-effect-peak', this.toggleAllLanesInEffectPeak);
			this.$bus.$on('block:list-expand-lane', this.onToggleExpandCustomizeLane);
			this.$bus.$on('block:list-expand-sidewalk', this.onToggleExpandCustomizeSidewalk);
			this.$bus.$on('block:list-expand-bicycle', this.onToggleExpandCustomizeBicycle);
			this.$bus.$on('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$on('block:show-on-map', this.showBlockOnMap);

			this.$bus.$on('swipe:right', this.onSwipeRight);
			this.$bus.$on('map:shown', this.changeToHideMap);
			this.$bus.$on('map:hidden', this.changeToShowMap);

			this.$bus.$on("attachment:updateComment",this.SaveAttachmentComment);
			this.$bus.$on("attachment:autoSave",this.SaveAttachmentComment);
			this.$bus.$on("attachment:delete", this.deleteAttachment);
		},
		SaveAttachmentComment(obj) {
			if (obj.comments != null && obj.comments != "" && obj.attachmentId != null) {
				let postData = {
					comments: obj.comments
				}
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/comment?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: postData
				}).then(resp => {

				}).catch(error => {
					this.isButtonDisabled = false;
					this.saving = false;
					if (error) {
						if (ErrorHandler.HasConnectionError(error)) {
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
					}
					}
					// if (!ErrorHandler.HasLoginErrorCode(error)) {
					// 	// this.laneClosureRequest.SetErrors(error.response.data);
					// 	this.showErrors(error.response.data.fields);
					// } else {
					// 	// ErrorHandler.RedirectToLogin();
					// }
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		deleteAttachment(obj) {
			//edit request tab DCZ, Transit, Parking
			this.isButtonDisabled = true;
			if (obj.userId != null && obj.attachmentId != null) {
				Vue.prototype.$http({
					method: 'delete',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/delete?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
				}).then(resp => {
					if(resp.status === 200){
						// Find the index of the attachment with the given id
						const index = this.laneClosure.attachment.findIndex((attachment) => attachment.id === obj.attachmentId);
						// If found, remove it from the array TO hide the deleted attachment tile from view
						if (index !== -1) {
							this.laneClosure.attachment.splice(index, 1);
						}
					}
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response) {
							this.laneClosure.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						}
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		handleFilePondAddFile(e, file, m) { },
		handleFilePondInit: function() {
			this.$refs.pond._pond.setOptions({
				server: {
					header: {
						Authorization: "Bearer " + this.$store.state.token
					},
					process: {
						method: 'POST',
						url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						withCredentials: true
					},
				}
			});
			this.$refs.pond._pond.setOptions({
				fileMetadataObject: {
					comments: null
				},
				allowImagePreview: false,
				allowRevert: false,
				allowReorder: false,
				allowReplace: false,
				server: {
					url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					headers: {
						Authorization: "Bearer " + this.$store.state.token
					}
				}
			});
		},

		handleFilePondProcessFileStart(e,p) {
			this.isButtonDisabled = true;
		},
		handleFilePondProcessAllFiles(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessError(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessAbort(e,p) {
			this.isButtonDisabled = false;
		},		handleFilePondProcessFile(e, p) {
			if (p.error) {
				// there was a problem!
			} else {
				let attachmentData = JSON.parse(p.serverId);
				this.downloadToken = attachmentData.downloadToken;
				this.downloadTokenExpires = attachmentData.downloadTokenExpires;
				this.laneClosure.attachment.unshift(new Attachment(attachmentData.attachment));
			}
		},
		toggleLaneInEffect(obj) {
			if (this.laneClosure.block[obj.block].lane[obj.lane].inEffect.value == 1) {
				this.laneClosure.block[obj.block].lane[obj.lane].inEffect.value = 0;
			} else {
				this.laneClosure.block[obj.block].lane[obj.lane].inEffect.value = 1;
			}
		},
		toggleAllLanesInEffect(data) {
			for (var x = 0; x < this.laneClosure.block.length; x++) {
				for (var xx = 0; xx < this.laneClosure.block[x].lane.length; xx++) {
					if (
						this.laneClosure.block[x].lane[xx].laneId.value == data.laneId
					) {
						this.laneClosure.block[x].lane[xx].inEffect.value = data.inEffect;
					}
				}
			}
		},
		toggleAllLanesInEffectPeak(data) {
			for (var x = 0; x < this.laneClosure.block.length; x++) {
				for (var xx = 0; xx < this.laneClosure.block[x].lane.length; xx++) {
					if (
						this.laneClosure.block[x].lane[xx].laneId.value == data.laneId &&
						this.laneClosure.block[x].lane[xx].peakId.value == data.peakId
					) {
						this.laneClosure.block[x].lane[xx].inEffect.value = data.inEffect;
					}
				}
			}
		},
		toggleSidewalkInEffect(obj) {
			if (obj.value == null) {
				if (this.laneClosure.block[obj.block].sidewalk[obj.sidewalk].inEffect.value == 1) {
					this.laneClosure.block[obj.block].sidewalk[obj.sidewalk].inEffect.value = 0;
				} else {
					this.laneClosure.block[obj.block].sidewalk[obj.sidewalk].inEffect.value = 1;
				}
			} else {
				this.laneClosure.block[obj.block].sidewalk[obj.sidewalk].inEffect.value = obj.value;
			}
		},
		toggleBicycleInEffect(obj) {
			if (obj.value == null) {
				if (this.laneClosure.block[obj.block]) {
					if (this.laneClosure.block[obj.block].bicycle[obj.bicycle]) {
						if (this.laneClosure.block[obj.block].bicycle[obj.bicycle].inEffect.value == 1) {
							this.laneClosure.block[obj.block].bicycle[obj.bicycle].inEffect.value = 0;
						} else {
							this.laneClosure.block[obj.block].bicycle[obj.bicycle].inEffect.value = 1;
						}
					}
				}
			} else {
				this.laneClosure.block[obj.block].bicycle[obj.bicycle].inEffect.value = obj.value;
			}
		},

		onAllLanesOpen() {
			if (this.laneClosure.block) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.laneClosure.block.length; x++) {
					for (xx = 0; xx < this.laneClosure.block[x].lane.length; xx++) {
						this.laneClosure.block[x].lane[xx].inEffect.value = 0;
					}
					for (xx = 0; xx < this.laneClosure.block[x].bicycle.length; xx++) {
						this.laneClosure.block[x].bicycle[xx].inEffect.value = 0;
					}
					for (xx = 0; xx < this.laneClosure.block[x].sidewalk.length; xx++) {
						this.laneClosure.block[x].sidewalk[xx].inEffect.value = 0;
					}
				}



			}
		},

		onAllLanesClosed() {
			if (this.laneClosure.block) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.laneClosure.block.length; x++) {
					for (xx = 0; xx < this.laneClosure.block[x].lane.length; xx++) {
						this.laneClosure.block[x].lane[xx].inEffect.value = 1;
					}
					for (xx = 0; xx < this.laneClosure.block[x].bicycle.length; xx++) {
						this.laneClosure.block[x].bicycle[xx].inEffect.value = 1;
					}
					for (xx = 0; xx < this.laneClosure.block[x].sidewalk.length; xx++) {
						this.laneClosure.block[x].sidewalk[xx].inEffect.value = 1;
					}
				}
			}
		},
		getBicycleText(bicycleId) {
			if (bicycleId) {
				return Format.searchById(bicycleId, LaneClosureRequest.getAffectBicycleOptions).name;
			}
			return "N/A";
		},

		getRestrictionPeakIdText(id) {
			if (id) {
				return Format.searchById(id, LaneClosureRequest.getRestrictionPeakReason).name;
			}
			return null;
		},
		getDirectionText(id) {
			if (id) {
				return Format.searchById(id, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},

		getRestrictionDirectionText(id) {
			if (id) {
				return Format.searchById(id, LaneClosureRequest.getRestrictionDirectionIdOptions).name;
			}
			return null;
		},
		getLanePeakReasonText(peakId) {
			if (peakId) {
				return Format.searchById(peakId, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},
		getLaneText(laneId) {
			if (laneId) {
				return Format.searchByGroupedId(laneId, LaneClosureRequest.getLaneAffectedOptions).name;
			}
			return null;
		},

		getParkingLaneRemovedText(laneId) {
			if (laneId) {
				return Format.searchById(laneId, LaneClosureRequest.getParkingLaneOptions).name;
			}
			return null;
		},

		getTransitText(transitId) {
			if (transitId !== null) {
				return Format.searchById(transitId, LaneClosureRequest.getAffectTransitOptions).name;
			}
			return null;
		},

		getParkingRemovalText(parkingRemovalId) {
			if (parkingRemovalId !== null) {
				return Format.searchById(parkingRemovalId, LaneClosureRequest.getParkingRemoveOptions).name;
			}
			return null;
		},
		getWorkDoneForText(workId) {
			if (workId) {
				return Format.searchById(workId, LaneClosureRequest.getMajorUtilitiesOptions).name;
			}
			return null;
		},



		getRestrictionTypeText(restrictionTypeId) {
			if (restrictionTypeId) {
				return Format.searchById(restrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).name;
			}
			return null;
		},

		getLaneImage(laneId) {
			if (laneId) {
				return Format.searchByGroupedId(laneId, LaneClosureRequest.getLaneAffectedOptions).img;
			}
			return null;
		},
		getRestrictionImage(restrictionTypeId) {
			if (restrictionTypeId) {
				return Format.searchById(restrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).img;
			}
			return null;
		},

		getLeftTurnSignalText(turn) {
			if (turn !== null) {
				return Format.searchById(turn, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getYesNoText(val) {
			if (val !== null) {
				return Format.searchById(val, LaneClosureRequest.getYesNoOptions).name;
			}
			return null;
		},

		getSidewalkText(sidewalkId) {
			if (sidewalkId) {
				return Format.searchById(sidewalkId, LaneClosureRequest.getSidewalkOptions).name;
			}
			return "N/A";
		},

		getDczRequiredText(dcz) {
			if (dcz) {
				return Format.searchById(dcz, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getBicycleLaneText(bicycleId) {
			if (bicycleId) {
				return Format.searchById(bicycleId, LaneClosureRequest.getBicycleLaneOptions).name;
			}
			return "N/A";
		},

		showOnMap(index) {
			Vue.prototype.$bus.$emit("map:toggle", null, null);
			this.$nextTick(() => {
				// this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
				this.$store.dispatch("map/zoomAllBlocks", null);
				let x = 0;
				for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
					if (this.$store.getters["map/polylines"][x]) {
						if (this.$store.getters["map/polylines"][x].blockData) {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
						}
					}
				}
			});
		},
		showBlockOnMap(data) {
			let id;
			if (data instanceof Object) {
				id = data.id;
			}
			else {
				id = data;
			}
			if (this.currentBlockOnMap && this.currentBlockOnMap instanceof Object) {
				if (this.currentBlockOnMap.id == data.id && this.currentBlockOnMap.type == data.type && this.currentBlockOnMap.laneId == data.laneId) {
					Vue.prototype.$bus.$emit("map:toggle", 0);
					this.currentBlockOnMap = null;
					return;
				}
			}

			this.currentBlockOnMap = data;
			Vue.prototype.$bus.$emit("map:toggle", 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToBlockId", id);
				// this.$store.dispatch("map/zoomToNearbyBlockIdPopup", id);
				// for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				// 	if (this.laneClosureRequest.block[x].blockId == id) {
				// 		this.zoomToBlock(x);
				// 		this.setPolylineColours(x);
				// 		this.$store.dispatch("map/zoomToNearbyBlockIdPopup", id);
				// 		break;
				// 	}
				// }

				let foundIndex = null;
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == id) {
						this.zoomToBlock(x);
						this.setPolylineColours(x);
						foundIndex =x;
						break;
					}
				}
				if (foundIndex != null) {
					this.$bus.$emit('map:block-closure-popup', {polyline:this.$store.getters["map/polylines"][foundIndex], e:null});
				}
			});
		},
		zoomAllBlocks() {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			if (this.laneClosure.block) {
				let x = 0;
				let z = 0;
				for (x = 0; x < this.laneClosure.block.length; x++) {
					if (this.laneClosure.block[x].mapPolyline) {
						let polyBounds = this.laneClosure.block[x].mapPolyline.getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}
						setBounds = true;
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},
		zoomToBlockId(id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			if (this.laneClosure.block) {
				let x = 0;
				let z = 0;
				for (x = 0; x < this.laneClosure.block.length; x++) {
					if (this.laneClosure.block[x].mapPolyline && this.laneClosure.block[x].blockId == id) {
						let polyBounds = this.laneClosure.block[x].mapPolyline.getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}
						setBounds = true;
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},
		zoomToBlock(index) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let x = 0;
			let z = 0;
			if (this.laneClosureRequest.block[index]) {
				if (this.$store.getters["map/polylines"]) {
					for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
						if (this.$store.getters["map/polylines"][x]) {
							if (this.$store.getters["map/polylines"][x].blockData) {
								if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
									let polyBounds = this.$store.getters["map/polylines"][x].getPath();
									for (z = 0; z < polyBounds.length; z++) {
										bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
									}
									setBounds = true;
								}
							}
						}
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},

		setPolylineColours(index) {
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#F2B942' });
						} else {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });


						}
					}
				}
			}

		},

		onSwipeRight() {
			// if the sub transitions are open, close them, otherwise go back.
			if (this.anyExpanded()) {
				Vue.prototype.$bus.$emit("swipe:right:panel",null);
			} else {
				this.$router.go(-1);
			}
		},

		setBlockPolyline(block) {
			let that = this;
			let foundIndex = null;
			let blockPolyline = null;
			if (block) {
				// find the existing marker/placemark.
				if (this.laneClosure.block) {
					for (var x = 0; x < this.laneClosure.block.length; x++) {
						if (this.laneClosure.block[x].blockId == block.blockId) {
							foundIndex = x;
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											blockPolyline = that.$store.getters["map/polylines"][x];
										}
									}
								}
							}
						}
					}
				}
				if (foundIndex == null || blockPolyline == null) {
					// add the block to the map.
					// look for existing block in lane closure request, and select it.
					var myParser = new Vue.prototype.$geoXML3.parser({
						map: null,
						afterParse: function(doc) {
							let xx = 0;
							var coords = [];
							let zz = 0;
							for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
								for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
									coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
								}
							}
							let mapPolyline = new google.maps.Polyline({
								map: that.$store.state.map.map,
								path: coords,
								strokeColor: '#666666',
								strokeOpacity: 1.0,
								strokeWeight: 8
							});
							mapPolyline.blockData = block;
							mapPolyline.laneClosureRequest = that.laneClosureRequest;

							let mapIndex = -1;
							if (foundIndex == null) {
								let newBlock = new LaneClosureRequestBlock(block);
								that.laneClosureRequest.block.push(newBlock);
								foundIndex = that.laneClosureRequest.block.length - 1;
							}
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
											mapIndex = x;
										}
									}
								}
							}
							if (mapIndex == -1) {
								// not found, so add the polyline.
								that.$store.commit("map/addPolyline", mapPolyline);
							}
							google.maps.event.addListener(mapPolyline, 'click', function() {
								if (that.$bus) {
									that.$bus.$emit('report-closure:map:block-edit', this.blockData.blockId);
								}
							});
							return;
						}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						if (block.streetName != that.laneClosureRequest.affectedStreet.value) {
							// turning restriction
							color = "7f000000"
						}
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				}
			}
		},

		onMapBlockClick: function(id) {
			let foundIndex = null;
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				if (this.laneClosureRequest.block[x].blockId == id) {
					this.zoomToBlock(x);
					this.setPolylineColours(x);
					foundIndex =x;
					break;
				}
			}
			if (foundIndex != null) {
				this.$bus.$emit('map:block-closure-popup', {polyline:this.$store.getters["map/polylines"][foundIndex], e:null});
			}
		},


		emailHref(value) {
			return "mailto:" + value;
		},

		onReportLaneClosure() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportClosure", params: { id: this.laneClosureRequest.id } });
			}
		},


		onFromDateTimeChanged: function(val) {
			if (this.laneClosureRequest.fromDate.value && val) {
						let fromTime = Format.fromUtc(val);
						let fromDate = Format.fromUtc(this.laneClosureRequest.fromDate.value);
				fromDate.minute(fromTime.minute());
				fromDate.hour(fromTime.hour());
				fromDate.seconds(0);
			}
		},
		// required fields notifying modal
		modalRequiredFieldClose() {
			this.showRequiredFieldModal = false;
		},

		showErrors(errors) {
			this.submissionStatus = 'submission-error';
			this.modalRequiredFieldList = [];
			for (let field in errors) {
				this.modalRequiredFieldList.push(errors[field]);
			}
			this.showRequiredFieldModal = true;
		},

		onSubmitOnly(evt) {
			// this.setRestrictionsAfter = false;
			this.onSubmit(evt);
		},

		onSubmitAndSetRestrictions(evt) {
			this.savingAndSet = true;
			this.saving = false;
			this.setRestrictionsAfter = true;
			this.onSubmit(evt);
		},
		onCancel() {
			let lastPage = this.$routerStore.getters['getLastListPage'];
			if (lastPage == null) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			} else {
				this.$router.push(lastPage);
			}
		},
		onSubmit(evt) {
			if (!this.savingAndSet) {
				this.saving = true;
			}
			evt.preventDefault()
			if (!this.validateFields()) {
				this.showUnsavedChangesModal = false;
				this.saving = false;
				return new Promise(function(resolve,reject){
					that.onSubmitPromiseDeferred.resolve = resolve;
					that.onSubmitPromiseDeferred.reject = reject;
					reject();
				});
			}
			let that = this;
			return new Promise(function(resolve, reject) {
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.PostLaneClosure(that.laneClosure);
			});

		},
		PostLaneClosure(t) {
			this.isButtonDisabled = true;
			let that = this;
			if (t instanceof LaneClosure) {
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/report-lane-closure?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						data: t.getRawValue()
					}
					).then(resp => {
						// Handle Success
						this.laneClosure.id = resp.data.id;
						this.submitted = 1;
						this.saveState = 'success';
						this.submissionStatus = 'submission-success';
						this.showUnsavedChangesModal = false;
						this.SaveNewSuccess();
						this.onSubmitPromiseDeferred.resolve();
					}).catch(error => {
						this.isButtonDisabled = false;
						this.saving = false;
						this.saveState = 'fail';
						if (ErrorHandler.HasConnectionError(error)) {
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:t.getRawValue()});
						}
						this.onSubmitPromiseDeferred.reject();
					}).finally(() => {
						that.isButtonDisabled = false;
						this.saving = false;
					});
				}
			} else {
				that.isButtonDisabled = false;
			}
		},
		SaveNewSuccess() {
			this.submitted = 1;
			this.saveSuccess = 2;
			this.laneClosure.saveChanges();
			if (this.setRestrictionsAfter) {
				this.$router.push({ name: "ReportRestriction", params: { id: this.laneClosureRequest.id } });
			} else {
				let lastPage = this.$routerStore.getters['getLastListPage'];
				if (lastPage == null) {
					this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
				} else {
					this.$router.push(lastPage);
				}
			}
		},

		onViewLaneClosureRequest() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			}
		},

		SearchReporter(input) {
			return new Promise((resolve, reject) => {
				// if (input.length < 1) {
				// 	return resolve([])
				// }
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable?q=' + encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		SearchReporterValue(result) {
			return result.firstName
		},
		// Addeds a transaction line with contact attached.
		HandleSelectReporter(selected) {
			this.reporter = selected;
			this.reporterId = selected.id;
			this.$refs.searchReporter.value = "";
		},

		validateFields() {
			let flag = true;
			let lcValid = this.laneClosure.validate();
			if (lcValid) { //  && restrictValid

						let closureDate = Format.fromUtc(this.laneClosure.fromDateTime.getRawValue());
						let lcrFromDate = Format.fromUtc(this.laneClosureRequest.fromDate.getRawValue());
				// let lcrToDate = this.moment(this.laneClosureRequest.toDate.getRawValue());
						let now = Format.fromUtc(this.moment.utc());
				if (now < closureDate) {
					this.laneClosure.fromDateTime.status = false;
					this.laneClosure.fromDateTime.invalidMessage = "Reporting date and time cannot be in the future";
					flag = false;
				}
						let validClosureDate = lcrFromDate.clone().subtract(1, 'days').startOf('day');
				if (validClosureDate > closureDate) {
					this.laneClosure.fromDateTime.status = false;
					this.laneClosure.fromDateTime.invalidMessage = "Reporting date and time cannot be earlier than 12 AM one day before the lane closure request Start date.";
					flag = false;
				}
				return flag;
			}
			return false;
		},

		checkLessThanTwoHours() {
			if (this.projectTimeDuration != null) {
				if (this.projectTimeDuration <= 0) {
					this.laneClosureRequest.toTime.invalidMessage = 'Estimated completion time cannot be earlier than requested start time';
					this.laneClosureRequest.toTime.status = false;
				} else if (this.projectTimeDuration < 2) {
					if (this.laneClosureRequest.isUnderTwoHours.value === false || this.laneClosureRequest.isUnderTwoHours.value === null) {
						this.lessThanTwoHourModalp1 = 'Estimated completion time is set to within two hours of requested start time.';
						this.lessThanTwoHourModalp2 = 'Do you want to set "Closure take less than 2 hours of total time" to "yes"?';
						this.showLessThanTwoHourModal = true;
					}
				} else {
					if (this.laneClosureRequest.isUnderTwoHours.value === true || this.laneClosureRequest.isUnderTwoHours.value === null) {
						this.lessThanTwoHourModalp1 = 'Estimated completion time is set to beyond two hours of requested start time.';
						this.lessThanTwoHourModalp2 = 'Do you want to set "Closure take less than 2 hours of total time" to "no"?';
						this.showLessThanTwoHourModal = true;
					}
				}
			}
		},

		lessThanTwoHoursModalOkClick() {
			if (this.projectTimeDuration != null) {
				if (this.projectTimeDuration < 2) {
					this.laneClosureRequest.isUnderTwoHours.value = true;
				} else if (this.projectTimeDuration > 2) {
					this.laneClosureRequest.isUnderTwoHours.value = false;
				}
			}
		},
		deleteAllMarkers() {
			//Loop through all the markers and remove
			for (var i = 0; i < this.markers.length; i++) {
				this.markers[i].setMap(null);
			}
			this.markers = [];
		},
		LoadLaneClosureRequest(id = this.id) {
			Vue.prototype.$bus.$emit("map:clear", 1);
			this.loaded = false;
			// Remove any messages being displayed.
			this.submissionStatus = null;

			if (id && Format.TryParseInt(id) > 0) {
				this.GetLaneClosureRequest(id);
			} else {
				if (this.data) {
					this.laneClosureRequest = new LaneClosureRequest(this.data);
					this.laneClosureRequest.saveChanges();
					this.$store.commit('laneClosureRequest/setData', this.laneClosureRequest);

				} else {
					this.laneClosureRequest = new LaneClosureRequest();
					// {useTestData:true}
				}
				this.loaded = true;
			}
		},
		// Loads lane closure request into the component based on provided id.
		GetLaneClosureRequest(id) {
			let that = this;
			if (Format.TryParseInt(id)) {
				this.loaded = false;
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/report-lane-closure?r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					// populate the lane closure request
					that.laneClosureRequest = new LaneClosureRequest(response.data.request);
					this.downloadToken = response.data.downloadToken;
					this.downloadTokenExpires = response.data.downloadTokenExpires;

					let fromDateTime = this.moment.utc();
					fromDateTime.seconds(0);

					// populate the lane closure with data from the lane closure request.
					if (response.data.closure) {
						let newData = {
							id: null,
							lcrId: response.data.closure.lcrId || null,
							ownerId: response.data.closure.ownerId || null,
							reporterId: response.data.closure.reporterId || null,
							fromDateTime: fromDateTime.format() || null,
							toDateTime: response.data.closure.toDateTime || null,
							inEffect: typeof response.data.closure.inEffect === 'number' ? response.data.closure.inEffect : null,
							numberLanesOpen: response.data.closure.numberLanesOpen || null,
							numberLanesClosed: response.data.closure.numberLanesClosed || null,
							trafficEffect: response.data.request.trafficEffect || null,
							block: response.data.request.block
						}
						// whoever is logged in is actually doing the reporting...
						that.reporter = that.$store.getters.userInfo();
						newData.reporterId = that.$store.getters.userId();

						that.laneClosure = new LaneClosure(newData);
						this.loaded = true;
					} else {
						// use the data from the lane closure request.
						let newData = {
							id: null,
							lcrId: response.data.request.id || null,
							ownerId: response.data.request.ownerId || null,
							reporterId: response.data.request.reporterId || null,
							fromDateTime: fromDateTime.format() || null,
							toDateTime: response.data.request.toDate || null,
							inEffect: typeof response.data.request.inEffect === 'number' ? response.data.request.inEffect : null,
							numberLanesOpen: response.data.request.numberLanesOpen || null,
							numberLanesClosed: response.data.request.numberLanesClosed || null,
							trafficEffect: response.data.request.trafficEffect || null,
							block: response.data.request.block
						};
						if (response.data.request.closureReporter == null) {
							that.reporter = response.data.request.requester;
							newData.reporterId = that.reporter.userId;
						} else {
							that.reporter = response.data.request.closureReporter;
							newData.reporterId = that.reporter.userId;
						}
						that.laneClosure = new LaneClosure(newData);
					}
					if (this.laneClosure.block) {
						let x = 0;
						for (x = 0; x < this.laneClosure.block.length; x++) {
							this.setBlockPolyline(this.laneClosure.block[x]);
						}
						this.zoomAllBlocks();
					}
					this.loaded = true;
					this.laneClosure.saveChanges();


				}).catch(error => {
					this.isButtonDisabled = false;
					this.saving = false;
					this.loaded = false;
					if (error) {
						if (ErrorHandler.HasConnectionError(error)) {
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
						}
					}
					// if (!ErrorHandler.HasLoginErrorCode(error)) {
					// 	if (error.response && error.response.data) {
					// 		this.loaded = false;
					// 		this.transactionStatus = 'load-error';
					// 		this.errorDetails = error.response.data;
					// 	}
					// } else {
					// 	// ErrorHandler.RedirectToLogin();
					// }
				});
			}
		},
		onToggleExpandCustomizeLane(value) {
			this.expandCustomizeLane["" + value.laneId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeSidewalk(value) {
			this.expandCustomizeSidewalk["" + value.sidewalkId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeBicycle(value) {
			this.expandCustomizeBicycle["" + value.bicycleLaneId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeRestriction(value) {
			this.expandCustomizeRestriction["" + value.restrictionTypeId + "," + value.directionId] = value.expand;
			this.forceRerender();
		},

		changeToHideMap() {
			this.hideMap = true;
		},
		changeToShowMap() {
			this.currentBlockOnMap = null;
			this.hideMap = false;
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			// Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
		});
	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.laneClosure.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				Vue.prototype.$bus.$emit("map:clear", 1);
				this.setEventBusOff();
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						this.showUnsavedChangesModal = false;
						Vue.prototype.$bus.$emit("map:clear", 1);
						this.setEventBusOff();
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					Vue.prototype.$bus.$emit("map:clear", 1);
					this.setEventBusOff();
					next(true);
				}).bind(this);

				next(false);
			}
		} else {
			Vue.prototype.$bus.$emit("map:clear", 1);
			this.setEventBusOff();
			next(true);
		}
	},
}
</script>